import { useContext } from 'react';
import snackbarContext from 'context/snackbar-context';

const useSnackbar = () => {
  return useContext(snackbarContext);
};

export default useSnackbar;
